import { ReactElement, useEffect, useRef } from 'react';
import { GraphContainer } from './styles';
import { useGenerateWaterGraph } from '../../hooks/useGenerateGraph';
import { WaterOverviewInfo } from '~/providers/types/api-private';

interface WaterGraphProps {
  data: WaterOverviewInfo | undefined;
  expanded: boolean;
}

export function WaterGraph({
  data,
  expanded,
}: Readonly<WaterGraphProps>): ReactElement {
  const chartReference = useRef<HTMLDivElement>(null);

  const { renderWaterChart } = useGenerateWaterGraph(chartReference, !data, expanded);

  useEffect(() => renderWaterChart(data), [data]);

  return (
    <GraphContainer>
      <div id="water-card" ref={chartReference} style={{ width: '100%', height: '100%' }} />
    </GraphContainer>
  );
}
